<template>
  <VueApexCharts
    ref="emsaChart"
    :options="options"
    :series="series"
    type="bar"
    height="350"
  ></VueApexCharts>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import emsaJson from "../../data.json";

export default {
  name: "Chart",
  props: {
    series: Array,
    category: Array,
    chartColors: Array
  },
  components: {
    VueApexCharts
  },
  computed: {
    getType() {
      return this.$route.params.type.toUpperCase();
    },
    rcoData() {
      let selectedRCOData = this.data[this.getType].Data;
      let selectedRCO = this.$store.state.firesafe.selectedRCO;
      let result = this.filterByValue(selectedRCOData, selectedRCO);
      return result[0];
    }
  },
  data: function() {
    return {
      data: emsaJson,
      options: {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false
          },
          fontFamily: "Roboto Condensed",
          animations: {
            enabled: true,
            easing: "swing", // linear, easeout, easein, easeinout, swing, bounce, elastic
            speed: 700,
            animateGradually: {
              delay: 600,
              enabled: true
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        colors: this.chartColors,
        plotOptions: {
          bar: {
            columnWidth: "70%",
            dataLabels: {
              position: "bottom" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            if (val === 0) {
              return "";
            }
            return val + "%";
          },
          style: {
            fontSize: "12px",
            colors: ["#FFFFFF"]
          },
          offsetY: 12
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        legend: {
          show: false
        },
        grid: {
          show: false
        },
        xaxis: {
          labels: {
            show: false
          },
          categories: this.category,
          position: "bottom",
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            show: false,
            formatter: function(val) {
              return val + "%";
            }
          },
          max: 10
        },
        row: {
          colors: undefined
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + "%";
            }
          }
        }
      }
    };
  },
  updated: function() {
    this.updateChart();
  },
  methods: {
    filterByValue(array, number) {
      return array.filter(function(rco) {
        return rco.Number === number;
      });
    },
    updateChart() {
      const newColors = this.chartColors;
      this.$refs.emsaChart.updateOptions({ colors: newColors }, true, true);
    }
  }
};
</script>

<style scoped></style>
